<template>
  <div>
    <v-form>
      <v-row>
        <v-col>
          <v-text-field
            v-model="form.date"
            type="date"
            label="Fecha"
            required
            :error-messages="errors['date']"
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col align="right">
          <v-spacer />
          <v-btn text color="primary" @click="save">Guardar</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import ValidationError from "@/errors/ValidationError";

export default defineComponent({
  setup() {
    const form = {
      date: null,
    };

    return {
      form,
    };
  },
  data() {
    return {
      errors: {},
    };
  },
  methods: {
    async save() {
      this.openLoader();

      try {
        const { message } = await this.postRequest(
          "settings/disabled-dates",
          this.form
        );

        this.showSuccessMessage(message);
        this.$emit("save");
      } catch (error) {
        if (error instanceof ValidationError) {
          this.errors = error.errors;
          return;
        }

        this.showErrorMessage(error.message);
      } finally {
        this.closeLoader();
      }
    },
  },
  mounted() {
    this.form = {};
  },
});
</script>
